<template>
    <div class="clickable" @click="selectFavorites">
        <spinner v-if="loading" size="sm"/>
        <template v-else-if="authStore.loggedInUser && searchFavorites">
            <heart-icon-filled :size="16" />
        </template>
        <template v-else>
            <heart-icon-empty :size="16" />
        </template>

        <modal v-if="showLoginModal" :open="loginModalOpen" @close="closeLoginModal">
            <template #default>
                <div class="text-center p-5" v-if="loggedInUserId">
                    <spinner size="lg"/>
                </div>
                <login-signup v-else :inline="true" :quickSignup="true" :showLoginForm="false" :showSignupForm="false" signupType="traveler" buttonsCssClass="py-5" instructions="Please login or sign up to search by your saved properties"/>
            
            </template>
        </modal>

        <slot />
    </div>
</template>

<script type="text/javascript">
    import HeartIconEmpty from '@/assets/icons/heart.svg.vue';
    import HeartIconFilled from '@/assets/icons/heart-filled.svg.vue';
    import LoginSignup from '@/components/Content/Auth/LoginSignup.vue';
    import CommonComponents from '@/components/Common.vue';

    import { UseApiStore } from '@/store/Api.js';
    import { UseAuthStore } from '@/store/Auth.js';
    import { UseUIStore } from '@/store/UI.js';

    export default {

        components: {
            HeartIconEmpty,
            HeartIconFilled,
            LoginSignup,
            ...CommonComponents,
        },

        setup() {
            return {
                apiStore: UseApiStore(),
                authStore: UseAuthStore(),
                uiStore: UseUIStore(),
            };
        },
        
        data() {
            return {
                showLoginModal: false,
                loginModalOpen: true,
                loggedInUserId: null,
                loading: false,
                pendingSearch: false,
            };
        },

        props: {
            searchFavorites: {
                type: Boolean,
                default: false,
            },
        },

        emits: ['search'],

        created() {
            if (this.authStore.loggedInUser) {
                this.loggedInUserId = this.authStore.loggedInUser.id;
                this.loading = true;
                this.requestIfNeeded();
            }
            // if the user is not logged in, reverse the selection
            else if (this.searchFavorites) {
                this.$emit('search', false);
            }

            // we'll watch user id change
            // so we can refresh the content as needed
            this.$watch(
                () => this.authStore.loggedInUser,

                (function(newVal) {
                    if (
                        (newVal) &&
                        (newVal.id)
                    ) {
                        if (newVal.id != this.loggedInUserId) {
                            this.loggedInUserId = newVal.id;
                        }
                    }
                    else {
                        this.loggedInUserId = null;
                    }
                }.bind(this)),

                { deep: true }
            );
        },

        watch: {
            loggedInUserId() {
                if (this.loggedInUserId) {
                    this.loading = true;
                    this.loginModalOpen = false;
                    this.requestIfNeeded();
                }
            },
        },

        computed: {


            requestUrl() {
                if (!this.loggedInUserId) return null;

                let url = 'travelers/properties/favorites?u='+this.loggedInUserId;
                return url;
            },

            userFavorites() {
                if (!this.requestUrl) return null;
                let response = this.apiStore.requests[this.requestUrl];
                
                if (!response) {
                    return null;
                }

                if ((response.valid) && (response.results) && (!response.results.error)) {
                    return response.results
                }
                
                return null;
            },
        },

        methods: {
            closeLoginModal() {
                this.showLoginModal = false;
                this.loginModalOpen = true;
            },

            requestIfNeeded() {
                if (!this.userFavorites) {
                    this.requestData();
                }
                else {
                    this.loading = false;

                    if (this.pendingSearch) {
                        this.pendingSearch = false;
                        setTimeout(this.selectFavorites, 120);
                    }
                }
            },

            async requestData(fresh) {

                if (!this.loggedInUserId) {
                    this.loading = false;
                    return null;
                }

                let payload = {
                    url: this.requestUrl,
                    forever: true,
                };

                if (fresh) payload.fresh = true;
                
                await this.apiStore.get(payload);

                this.loading = false;
                if (this.pendingSearch) {
                    this.pendingSearch = false;
                    setTimeout(this.selectFavorites, 120);
                }
            },

            selectFavorites() {
                if (this.loading) {
                    return;
                }
                if (this.loggedInUserId) {
                    if (
                        (this.userFavorites) &&
                        (this.userFavorites.favorites) &&
                        (this.userFavorites.favorites.length)
                    ) {
                        this.pendingSearch = false;
                        this.$emit('search', !this.searchFavorites);
                    }
                    else {
                        this.uiStore.toast({
                            info: true,
                            message: 'You don\'t have any saved properties. Click on the save icon on the properties you like to use this search.'
                        });
                    }
                }
                else {
                    this.loginModalOpen = true;
                    this.showLoginModal = true;
                    this.pendingSearch = true;
                }
            },

            favoriteProperties() {
                if (
                    (this.userFavorites) &&
                    (this.userFavorites.favorites) &&
                    (this.userFavorites.favorites.length)
                ) {
                    return this.userFavorites.favorites;
                }
                return null;
            },
        }
    };

</script>
